function bindInfoboxChangeListener() {
  var preview_infobox = function(textarea) {
    $(".infobox").html(textarea.val());
  };
  var textarea = $("textarea#campaign_infobox");
  // initial preview
  preview_infobox(textarea);
  // later preview
  textarea.change(function(ev) {
    preview_infobox($(ev.target));
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = bindInfoboxChangeListener;